module.exports = __webpack_public_path__ + "img/gray-phone.b97fa9ad.png";